module.exports = __webpack_public_path__ + "img/18.b30db519.jpg";